export const ORDER = {
  ASC: 1,
  DESC: -1
};
